module.exports = __webpack_public_path__ + "img/x-pattern-overlay.a025d86.svg";